export const MomentOption = {
	FROM_NOW: 'FromNow',
	TO_NOW: 'ToNow',
	FROM: 'From',
	TO: 'To',
	DURATION: 'Duration',
	DURATION_NOW: 'DurationNow'
}
